import React, { useState, useEffect, Suspense } from "react";

import { Paper, TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  ModalDeleteConfirm,
  Title,
  TableCellDefault,
  Loading,
  TableAction,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";
import { useDatatablesServerSide, useDatatables } from "App/hooks";

import {
  deletePoById,
  getByFilterPO,
  headCells,
  RenderStatusPoBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers";

import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
} from "App/utils/helpers";

import { BASE_URL_4, instance4, WMS_PBF_PO } from "App/constants";
import FormFilterDaftarPO from "./FormFilterDaftarPO";
import { STATUS_TRANSAKSI_PENGAJUAN } from "../PurchaseOrder/helpers";
import { FreezeTable } from "components/organism";
import {
  changeActiveMenu,
  changeActiveTab,
  changePagePropsWfPurchaseOrder,
} from "App/Component/layout/Wrapper/context/actions";
import { useDispatchWrapper } from "hooks";
import { LoadingBackdrop } from "components/atoms";
import fileDownload from "js-file-download";
import { itSelfEmpty } from "utils/all";

export default function DaftarPo() {
  const classes = STYLE_DEFAULT_MASTER();
  const [poID, setPoId] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const { dispatch, handleClickMenu } = useDispatchWrapper();
  const handleClickUpdate = (row) => {
    Promise.resolve()
      .then(() => {
        dispatch(changeActiveMenu(WMS_PBF_PO));
      })
      .then(async () => {
        const propsPageWfPurchaseOrder = {
          idpo: row?.POId,
          noPO: row?.nomorPO,
          date: defaultDateInputDisplay(row?.date, true),
          gudang_id: row?.gudang_id,
          gudang: row?.namaGudang,
          supplier_id: row?.supplier_id,
          supplier: row?.namaSuplier,
          penerima: row?.penerima,
          remark: row?.remark,
          type: "update",
          status: row?.status,
          isOpenDraf: true,
          isProcess: row?.status,
          jumlah: 0,
          tax: row?.tax === null ? 0 : row?.tax,
          potongan: row?.potongan === null ? 0 : row?.potongan,
          potongan2: row?.potongan === null ? 0 : formatRupiah(row?.potongan),
          total_jumlah: 0,
          is_persentase_potongan: false,
          diskon_persen: 0,
        };

        dispatch(changePagePropsWfPurchaseOrder(propsPageWfPurchaseOrder));
        dispatch(changeActiveTab(WMS_PBF_PO));

        handleClickMenu({
          code: WMS_PBF_PO,
          name: "PO",
        });
        setLoading(false);
      });

    // Promise.resolve()
    //   .then(() => {
    //     changeMenu(WMS_PBF_PO);
    //   })
    //   .then(() => {
    //     changeParentData({
    //       idpo: row?.POId,
    //       date: defaultDateInputDisplay(row?.date, true),
    //       gudang_id: row?.gudang_id,
    //       gudang: row?.namaGudang,
    //       supplier_id: row?.supplier_id,
    //       supplier: row?.namaSuplier,
    //       penerima: row?.penerima,
    //       remark: row?.remark,
    //       type: "update",
    //       status: row?.status,
    //       isOpenDraf: true,
    //       isProcess: row?.status,
    //       jumlah: 0,
    //       tax: row?.tax === null ? 0 : row?.tax,
    //       total_jumlah: 0,
    //     });
    //     changeTitle(WMS_PBF_PO);
    //     handleClickMenu({
    //       code: WMS_PBF_PO,
    //       name: "PO",
    //     });
    //   });
  };

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterPO(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setPoId(row?.POId);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deletePoById(poID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  function strReplace(str) {
    var newStr = "";
    for (var i = 0; i < str.length; i++) {
      if (str[i] === "/") {
        newStr += "_";
      } else {
        newStr += str[i];
      }
    }
    return newStr;
  }

  const downloadPDF = async (id, name) => {
    setLoading(true);
    const filename = strReplace(name);
    try {
      const api = await instance4.get(
        `${BASE_URL_4}/wmsfarmasi/POList/download_pdf/${id}`,
        {
          responseType: "blob",
        }
      );
      fileDownload(api.data, filename + ".pdf");
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
    setLoading(false);
  };

  return (
    <Suspense fallback={<LoadingBackdrop />}>
      <div className={classes.root}>
        <Title title={"Daftar PO Perbekalan Farmasi"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarPO
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarPO
            rows={rows}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
            downloadPDF={downloadPDF}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </Suspense>
  );
}

const TableDaftarPO = ({ rows, handleClickUpdate, handleClickDelete, downloadPDF }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "POId",
    orderByRow: ["POId"],
  });

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}>
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover key={index}>
            <TableCell align='center'>{index + 1}</TableCell>

            <TableCell align='center'>
              <TableAction
                isDownload={true}
                clickDownload={() => downloadPDF(row.POId, row?.nomorPO)}
                clickUpdate={() => handleClickUpdate(row)}
                clickDelete={() => handleClickDelete(row)}
                isDelete={row.status_transaksi === STATUS_TRANSAKSI_PENGAJUAN}

              />
            </TableCell>
            <TableCell align='left'>{row?.POId}</TableCell>
            <TableCell align='left'>{row?.nomorPO}</TableCell>
            <TableCell align='left'>{row?.pembelian_id}</TableCell>
            <TableCell align='left'>{defaultDateDisplay(row?.date)}</TableCell>
            <TableCell align='left'>{row?.namaGudang}</TableCell>
            <TableCell align='left'>{row?.namaSuplier}</TableCell>
            <TableCell align='left'>
              <RenderStatusPoBadge status={row.status_transaksi} />
            </TableCell>

            <TableCell align='left'>{row?.processedBy}</TableCell>
            <TableCell align='right'>
              {row.jumlahTotal === null
                ? "0"
                : formatNumber(
                    row.jumlahTotal -
                      row.totalSetDisc - itSelfEmpty(row?.potongan, 0) +
                      (row.tax / 100) * (row.jumlahTotal - row.totalSetDisc  - itSelfEmpty(row?.potongan, 0))
                  )}
            </TableCell>
            <TableCell align='left'>{row?.penerima}</TableCell>

            <TableCellDefault row={row} />
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align='center' colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
